<template>
  <div id="changeUserInfo">
    <!-- 左侧边栏 -->
    <ul class="changeInfoLeftSideBar" :style="isProjectBarShow?{width:'230px'}:{width:'110px'}">
      <li style="cursor: default;">
        <img
          style="margin-left:42px;width:26px;cursor: pointer;"
          @click="handleProjectSideBarSild"
          src="../../assets/image/icon_zk@2x.png"
          alt
        />
        <!-- <i class="projectSideBarIcon el-icon-s-unfold"></i> -->
      </li>
      <li
        v-if="isProjectBarShow"
        @click="sidBarSelect('1')"
        :class="sideBarActive=='1'?'leftSideBarActive':''"
      >
        <img src="../../assets/image/icon_quanbu@2x.png" alt />
        <span>全部项目</span>
      </li>
      <li
        v-if="isProjectBarShow"
        @click="sidBarSelect('2')"
        :class="sideBarActive=='2'?'leftSideBarActive':''"
      >
        <img src="../../assets/image/icon_guanzhu@2x.png" alt />
        <span>关注项目</span>
      </li>
      <li
        v-if="isProjectBarShow"
        @click="sidBarSelect('3')"
        :class="sideBarActive=='3'?'leftSideBarActive':''"
      >
        <img src="../../assets/image/icon_fenlei@2x.png" alt />
        <span>许可分类</span>
      </li>
      <li
        v-if="isProjectBarShow"
        @click="sidBarSelect('4')"
        :class="sideBarActive=='4'?'leftSideBarActive':''"
      >
        <img src="../../assets/image/icon_guidang@2x.png" alt />
        <span>归档项目</span>
      </li>
      <!-- 缩小的 -->
      <li v-if="!isProjectBarShow" @click="sidBarSelect('1')" class="smallLi">
        <div class="logoBgc" :class="sideBarActive=='1'?'leftSideBarActiveSmall':''">
          <img src="../../assets/image/icon_quanbu@2x.png" alt />
        </div>
      </li>
      <li v-if="!isProjectBarShow" @click="sidBarSelect('2')" class="smallLi">
        <div class="logoBgc" :class="sideBarActive=='2'?'leftSideBarActiveSmall':''">
          <img src="../../assets/image/icon_guanzhu@2x.png" alt />
        </div>
      </li>
      <li v-if="!isProjectBarShow" @click="sidBarSelect('3')" class="smallLi">
        <div class="logoBgc" :class="sideBarActive=='3'?'leftSideBarActiveSmall':''">
          <img src="../../assets/image/icon_fenlei@2x.png" alt />
        </div>
      </li>
      <li v-if="!isProjectBarShow" @click="sidBarSelect('4')" class="smallLi">
        <div class="logoBgc" :class="sideBarActive=='4'?'leftSideBarActiveSmall':''">
          <img src="../../assets/image/icon_guidang@2x.png" alt />
        </div>
      </li>
    </ul>
    <!-- 右边主体 -->
    <div
      class="changeUserInfoBox"
      :style="isProjectBarShow?{width: 'calc(100% - 230px)'}:{width: 'calc(100% - 110px)'}"
    >
      <keep-alive include="projectIndex,projectAttention,projectClassify,projectSave">
        <router-view />
      </keep-alive>
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {
      isProjectBarShow: true,
      sideBarActive: '1',
      activeName: 'username',
      isDisable: true,
    }
  },
  methods: {
    handleProjectSideBarSild() {
      this.isProjectBarShow = !this.isProjectBarShow
    },
    handleClick(tab, event) {},
    handleAddSubmit() {},
    handleCanel() {},
    sidBarSelect(val) {
      this.sideBarActive = val
      if (val == '1') {
        if (this.$route.path == '/project/index') return
        this.$router.push({
          path: '/project/index',
        })
      }
      if (val == '2') {
        if (this.$route.path == '/project/attention') return
        this.$router.push({
          path: '/project/attention',
        })
      }
      if (val == '3') {
        if (this.$route.path == '/project/classify') return
        this.$router.push({
          path: '/project/classify',
        })
      }
      if (val == '4') {
        if (this.$route.path == '/project/save') return
        this.$router.push({
          path: '/project/save',
        })
      }
    },
  },
  watch: {
    '$route.path': function (newVal, oldVal) {
      //console.log(newVal+"---"+oldVal);
      if (newVal == '/project/index') {
        this.sideBarActive = '1'
      }
    },
  },
  created() {
    // this.sideBarActive = '1'
    if (this.$route.path == '/project/index') {
      this.sideBarActive = '1'
      if (this.$route.query.type == 'attention') {
        // this.sideBarActive = '2'
      }
    }
    if (this.$route.path == '/project/attention') {
      this.sideBarActive = '2'
    }
    if (this.$route.path == '/project/save') {
      this.sideBarActive = '4'
    }
  },
}
</script>
<style lang="less" scoped>
#changeUserInfo {
  width: 100%;
  height: 92%;
  background-color: #f2f3f4;
  display: flex;
  // 左侧边栏
  .changeInfoLeftSideBar {
    height: 100%;
    background-color: #1c7aca;
    li {
      cursor: pointer;
      display: flex;
      align-items: center;
      width: 100%;
      height: 95px;
      color: #fff;
      font-size: 18px;
      font-weight: 700;
      .projectSideBarIcon {
        cursor: pointer;
        font-size: 36px;
        margin-left: 42px;
      }
      img {
        width: 20px;
        margin-left: 52px;
        margin-right: 15px;
      }
    }
    .smallLi {
      display: flex;
      align-items: center;
      // background-color: #1c7aca !important;
      .logoBgc {
        width: 72px;
        height: 72px;
        border-radius: 36px;

        display: flex;
        align-items: center;
        justify-content: center;
        margin-left: 19px;
        img {
          width: 25px;
          margin: 0;
        }
      }
    }
    .leftSideBarActiveSmall {
      background-color: #40a0f2;
    }
    .leftSideBarActive {
      background-color: #40a0f2;
      color: #fff;
    }
  }
  // 右主体表单
  .changeUserInfoBox {
    height: 100%;
    overflow-y: auto;
    box-sizing: border-box;
  }
}
</style>